import { Form } from "react-bootstrap"
import { AMENITY_COPY_MODE_OPTIONS, AmenityCopyMode, PropertyAmenityDoc } from "../../../Hooks/UseAmenities/usePropertyAmenityCopyHook"
import useAmenityRefs from "../../../Hooks/UseAmenities/useAmenityRefsHook"

export default function CopyAmenitiesOptions(props: {
    idPrefix: string
    sourceAmenities: PropertyAmenityDoc[]
    selectedAmenityIds: string[]
    onToggleAmenity: (amenityId: string) => void
    mode: AmenityCopyMode
    onModeChange: (mode: AmenityCopyMode) => void
}) {
    const {
        idPrefix,
        sourceAmenities,
        selectedAmenityIds,
        onToggleAmenity,
        mode,
        onModeChange,
    } = props

    const amenityRef = useAmenityRefs()

    const sortedAmenities = [...sourceAmenities].sort((a, b) =>
        (amenityRef[a.amenityId]?.title || a.amenityId).localeCompare(amenityRef[b.amenityId]?.title || b.amenityId)
    )

    return (
        <div>
            <div className="mb-2">
                <div className="fw-bold" style={{ fontSize: '0.85rem' }}>Copy mode</div>
                {AMENITY_COPY_MODE_OPTIONS.map((option) => (
                    <div key={option.value}>
                        <Form.Check
                            type="radio"
                            id={`${idPrefix}-mode-${option.value}`}
                            name={`${idPrefix}-mode`}
                            label={option.label}
                            checked={mode === option.value}
                            onChange={() => onModeChange(option.value)}
                        />
                        {mode === option.value && (
                            <div
                                className={option.value === 'replace-all' ? 'ms-4 text-danger' : 'ms-4 text-muted'}
                                style={{ fontSize: '0.75rem' }}
                            >
                                {option.description}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div>
                <div className="fw-bold" style={{ fontSize: '0.85rem' }}>Amenities to copy</div>
                <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                    None checked copies all {sourceAmenities.length} amenities, including their overrides.
                </div>
                {sortedAmenities.length === 0 && (
                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>No amenities found on the source.</div>
                )}
                {sortedAmenities.map((pa) => (
                    <Form.Check
                        key={pa._id}
                        inline
                        type="checkbox"
                        id={`${idPrefix}-amenity-${pa._id}`}
                        label={amenityRef[pa.amenityId]?.title || pa.amenityId}
                        checked={selectedAmenityIds.includes(pa.amenityId)}
                        onChange={() => onToggleAmenity(pa.amenityId)}
                    />
                ))}
            </div>
        </div>
    )
}
